import _ from 'lodash';

import {VIEW_NAMES_ENUM} from './ViewNames';

export const ACTUALS = "Actuals";

export const PRE_RECEIVE_WORKPOOLS_ENUM = {
    NOT_YET_ARRIVED: "Not Yet Arrived",
    IN_YARD: "In Yard",
    PRE_RECEIVE_DEFECT: "Pre Receive Defect",
    NOT_YET_RECEIVED: "Not Yet Received",
    UNLOADED: "Unloaded"
};

export const POST_RECEIVE_WORKPOOLS_ENUM = {
    TRANS_RECEIVED: "Trans Received",
    UNLOADED: "Unloaded",
    VENDOR_RECEIVED: "Vendor Received",
    UNLOADED_TO_CONVEYANCE: "Unloaded To Conveyance",
    DECANTED: "Decanted",
    PENDING_STOW: "Pending Stow",
    STOWED: "Stowed"
};

export const TOP_PRE_RECEIVE_WORKPOOLS_ENUM = {
    NOT_YET_ARRIVED: "NotYetArrived",
    IN_YARD: "InYard",
    PRE_RECEIVE_DEFECT: "PreReceiveDefect",
    NOT_YET_RECEIVED: "NotYetReceived",
    UNLOADED: "Unloaded"
};

export const DWELL_TIME_WORKPOOLS_ENUM = {...PRE_RECEIVE_WORKPOOLS_ENUM, ...POST_RECEIVE_WORKPOOLS_ENUM};

export const PRE_RECEIVE_WORKPOOLS_VALUE_TO_LABEL_MAP = new Map(_.values(PRE_RECEIVE_WORKPOOLS_ENUM).map((workPoolName) => [_.replace(workPoolName, / /g, ""), workPoolName]));
export const POST_RECEIVE_WORKPOOLS_VALUE_TO_LABEL_MAP = new Map(_.values(POST_RECEIVE_WORKPOOLS_ENUM).map((workPoolName) => [_.replace(workPoolName, / /g, ""), workPoolName]));
export const DWELL_TIME_WORKPOOLS_VALUE_TO_LABEL_MAP = new Map(_.values(DWELL_TIME_WORKPOOLS_ENUM).map((workPoolName) => [_.replace(workPoolName, / /g, ""), workPoolName]));

export const DWELL_TIME_WORKPOOLS_WITHOUT_SUB_WORKPOOLS_ENUM = {...TOP_PRE_RECEIVE_WORKPOOLS_ENUM, ...Array.from(POST_RECEIVE_WORKPOOLS_VALUE_TO_LABEL_MAP.keys())};

export const VIEW_NAME_TO_WORK_POOL_NAME_MAP = new Map([
    [VIEW_NAMES_ENUM.PRE_RECEIVE, PRE_RECEIVE_WORKPOOLS_VALUE_TO_LABEL_MAP],
    [VIEW_NAMES_ENUM.PRE_RECEIVE_WORK_VIEW, PRE_RECEIVE_WORKPOOLS_VALUE_TO_LABEL_MAP],
    [VIEW_NAMES_ENUM.POST_RECEIVE, POST_RECEIVE_WORKPOOLS_VALUE_TO_LABEL_MAP],
    [VIEW_NAMES_ENUM.POST_RECEIVE_WORK_VIEW, POST_RECEIVE_WORKPOOLS_VALUE_TO_LABEL_MAP],
    [VIEW_NAMES_ENUM.DWELL_TIME, DWELL_TIME_WORKPOOLS_VALUE_TO_LABEL_MAP]
]);

export const VIEW_NAME_TO_WORK_POOL_NAME_MAP_WITHOUT_FORECAST = new Map([
    [VIEW_NAMES_ENUM.PRE_RECEIVE, new Map(_.values(TOP_PRE_RECEIVE_WORKPOOLS_ENUM).map((workPoolName) => [workPoolName, workPoolName]))],
    [VIEW_NAMES_ENUM.PRE_RECEIVE_WORK_VIEW, new Map(_.values(TOP_PRE_RECEIVE_WORKPOOLS_ENUM).map((workPoolName) => [workPoolName, workPoolName]))],
    [VIEW_NAMES_ENUM.POST_RECEIVE, new Map(_.values(POST_RECEIVE_WORKPOOLS_ENUM).map((workPoolName) => [_.replace(workPoolName, / /g, ""), workPoolName]))],
    [VIEW_NAMES_ENUM.POST_RECEIVE_WORK_VIEW, new Map(_.values(POST_RECEIVE_WORKPOOLS_ENUM).map((workPoolName) => [_.replace(workPoolName, / /g, ""), workPoolName]))],
    [VIEW_NAMES_ENUM.DWELL_TIME, new Map(_.values(DWELL_TIME_WORKPOOLS_WITHOUT_SUB_WORKPOOLS_ENUM).map((workPoolName) => [workPoolName, workPoolName]))]
]);
